import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { HTTP_METHOD } from '../constants';
import {
  getBaseQuery,
  TransformedErrorResponseWithNotification,
} from '../generic';
import { IRole } from '../../../types/interfaces/role';
import * as endpoints from '../endpoints';
import { IExercise } from '../../../types/interfaces/exercise';
import { IUser } from '../../../types/interfaces/user';
import { ICommunity } from '../../../types/interfaces/community';

export const searchApi = createApi({
  reducerPath: 'searchApi',
  tagTypes: [],
  baseQuery: getBaseQuery(),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getGlobalSearchApi: builder.query<
      { exercises: IExercise[]; users: IUser[]; communities: ICommunity[] },
      {
        searchValue: string;
        limit: number;
      }
    >({
      keepUnusedDataFor: 0,
      query({ searchValue, limit }) {
        return {
          url: `${endpoints.Search.ROOT}${endpoints.Search.GLOBAL}?searchValue=${searchValue}&limit=${limit}`,
          method: HTTP_METHOD.GET,
        };
      },
      ...TransformedErrorResponseWithNotification(),
    }),
  }),
});

export const { useLazyGetGlobalSearchApiQuery: useLazyGetGlobalSearch } =
  searchApi;
